<div *ngIf="isDisabled; else theButton">
  <div class="input-group">
    <button class="btn btn-block btn-sm btn-primary" disabled="disabled" translate>CONTACT_US</button>
  </div>
</div>

<ng-template #theButton>
  <div class="input-group">
    <div class="input-group-prepend">
      <button class="btn btn-primary btn-sm" (click)="sub(); $event.preventDefault(); $event.stopPropagation()">
        <i class="fas fa-minus"></i>
      </button>
    </div>
    <input
      type="number"
      class="form-control form-control-sm text-center"
      [(ngModel)]="currentQty"
      #inputElement
      (ngModelChange)="set($event, inputElement)"
      (click)="$event.preventDefault(); $event.stopPropagation()"
      [ngModelOptions]="{ updateOn: 'blur' }"
    />
    <div class="input-group-append">
      <button class="btn btn-sm btn-primary" (click)="add(); $event.preventDefault(); $event.stopPropagation()">
        <i class="fas fa-plus"></i>
      </button>
    </div>
  </div>

  <!-- <ng-template #btn>
        <div class="input-group">
            <button class="btn btn-block btn-sm btn-primary"
                (click)="add(); $event.preventDefault(); $event.stopPropagation();" translate>ADD_TO_CART</button>
        </div>
    </ng-template> -->

  <!--<div *ngIf="colmecHasRimOptions" class="input-group">
    <button
      type="button"
      class="btn btn-sm btn-primary w-100 mt-1"
      (click)="openRimModal()"
      [disabled]="currentQty == 0 ? true : null"
      translate
    >
      ADD_RIM
    </button>
  </div>-->
</ng-template>
